export default "__VITE_ASSET__f5zQ4NI$__"